'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const queryStringToObject = (search, arrayKey = []) => {
  const urlParams = new URLSearchParams(search);
  const result = {};
  for (const [key, value] of urlParams) {
    if (typeof value === "string") {
      if (arrayKey.includes(key)) {
        result[key] = value.split(",");
      } else {
        result[key] = value.trim();
      }
    } else
      result[key] = value;
  }
  return result;
};

exports.queryStringToObject = queryStringToObject;
